// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.ContractItem_contract-item__3TrEX {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ContractItem_custom-background__SNIMS {
  background-color: #BDF2A0 !important;
}

.ContractItem_info-message__IPFlq {
  margin-bottom: 20px;
}
.ContractItem_info-message__IPFlq a {
  width: 100%;
  font-weight: 500;
  font-size: 16px;
}
.ContractItem_info-message__IPFlq a:hover {
  text-decoration: none;
}

.ContractItem_claim-button__qctcC {
  width: 200px;
}

.ContractItem_card__MO5nl:not(:last-child) {
  margin-bottom: 12px;
}

.ContractItem_main-card__4GrNQ {
  width: 100%;
}

.ContractItem_secondary-cards__Jl1az {
  width: 100%;
  column-count: 2;
  gap: 12px;
}

.ContractItem_contract-name__yBMj4 {
  margin-bottom: 8px;
  color: #00007a;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
}

.ContractItem_download__Bspw0 {
  margin-left: 12px;
}

.ContractItem_price__f7YlF {
  align-items: baseline;
  cursor: initial;
}
.ContractItem_price__f7YlF span {
  font-weight: 500;
  font-size: 28px;
  line-height: 32px;
}

.ContractItem_modal-title__Uc\\+i1 {
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.ContractItem_modal-description__aCoTT {
  margin-bottom: 32px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #00007a;
}

.ContractItem_modal-button__SVaOZ {
  width: 160px;
}

.ContractItem_cancel-button__f\\+-Gc {
  width: 200px;
  margin-top: 40px;
}

.ContractItem_guarantee__cQaUs {
  padding: 0 !important;
  margin: 0;
}
.ContractItem_guarantee__cQaUs div, .ContractItem_guarantee__cQaUs ul {
  padding: 0;
  margin: 0 !important;
}
.ContractItem_guarantee__cQaUs h4 {
  color: #00007a;
}
.ContractItem_guarantee__cQaUs li {
  list-style-type: none;
  font-weight: 300;
  padding: 4px 0 0 18px;
  position: relative;
}
.ContractItem_guarantee__cQaUs li span {
  font-weight: 400;
}
.ContractItem_guarantee__cQaUs li svg {
  vertical-align: middle;
  margin: 0 10px;
}
.ContractItem_guarantee__cQaUs li svg path {
  fill: #00007a;
}
.ContractItem_guarantee__cQaUs li:before {
  width: 8px;
  height: 8px;
  position: absolute;
  left: 0;
  top: 15px;
  content: "";
  display: inline-block;
  border-radius: 50%;
  background-color: #d8d8ff;
}
.ContractItem_guarantee__cQaUs:not(:last-child) {
  border-bottom: 1px solid #d8d8ff;
  border-radius: 0;
  padding-bottom: 10px !important;
  margin-bottom: 10px;
}

@media screen and (max-width: 600px) {
  .ContractItem_secondary-cards__Jl1az {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
  }
  .ContractItem_card__MO5nl:not(:last-child) {
    margin-bottom: 0;
  }
  .ContractItem_card__MO5nl:nth-child(2) {
    order: 1;
  }
  .ContractItem_card__MO5nl:nth-child(4) {
    order: 1;
  }
  .ContractItem_cancel-button__f\\+-Gc {
    width: 100%;
  }
}
.ContractItem_custom-info-message__F7n3d {
  display: flex;
  align-items: center; /* Aligne verticalement */
  justify-content: space-between;
  background-color: #FEF9F0;
  border: 1px solid #FBD298;
  color: #B94402;
}

.ContractItem_custom-claim-button__ZafVJ {
  padding: 0 20px; /* Ajuster en fonction de la taille du texte */
  font-size: inherit; /* Pour qu'il suive la taille du texte */
  width: auto; /* S'assure que le bouton prend la taille du texte */
  white-space: nowrap; /* Empêche le texte de se couper en plusieurs lignes */
}

.ContractItem_custom-claim-button__ZafVJ:hover {
  background-color: #FEF9F0; /* Si vous voulez que le bouton change au hover */
}`, "",{"version":3,"sources":["webpack://./src/components/Contracts/ContractItem/ContractItem.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAKF;;AAHA;EACE,oCAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;AAJE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAMJ;AAJI;EACE,qBAAA;AAMN;;AADA;EACE,YAAA;AAIF;;AAAE;EACE,mBAAA;AAGJ;;AACA;EACE,WAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,SAAA;AAEF;;AACA;EACE,kBAAA;EACA,cCzCS;ED0CT,gBAAA;EACA,eAAA;EACA,iBAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,qBAAA;EACA,eAAA;AAEF;AAAE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnES;ADoEX;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3ES;AD4EX;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,SAAA;AACF;AACE;EACE,UAAA;EACA,oBAAA;AACJ;AAEE;EACC,cCjGQ;ADiGX;AAGE;EACE,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,sBAAA;EACA,cAAA;AAFN;AAIM;EACE,aCnHG;ADiHX;AAMI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBCtIK;ADkIX;AAQE;EACE,gCAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AANJ;;AAUA;EACE;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;EAPF;EAWE;IACE,gBAAA;EATJ;EAYE;IACE,QAAA;EAVJ;EAYE;IACE,QAAA;EAVJ;EAcA;IACE,WAAA;EAZF;AACF;AAcA;EACE,aAAA;EACA,mBAAA,EAAA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AAZF;;AAeA;EACE,eAAA,EAAA,8CAAA;EACA,kBAAA,EAAA,wCAAA;EACA,WAAA,EAAA,oDAAA;EACA,mBAAA,EAAA,sDAAA;AAZF;;AAeA;EACE,yBAAA,EAAA,iDAAA;AAZF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.contract-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.custom-background {\n  background-color: #BDF2A0 !important;\n}\n\n.info-message {\n  margin-bottom: 20px;\n\n  a {\n    width: 100%;\n    font-weight: 500;\n    font-size: 16px;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.claim-button {\n  width: 200px;\n}\n\n.card {\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n}\n\n.main-card {\n  width: 100%;\n}\n\n.secondary-cards {\n  width: 100%;\n  column-count: 2;\n  gap: 12px;\n}\n\n.contract-name {\n  margin-bottom: 8px;\n  color: colors.$primary8;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 36px;\n}\n\n.download {\n  margin-left: 12px;\n}\n\n.price {\n  align-items: baseline;\n  cursor: initial;\n\n  span {\n    font-weight: 500;\n    font-size: 28px;\n    line-height: 32px;\n  }\n}\n\n.modal-title {\n  margin-bottom: 20px;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 36px;\n  color: colors.$primary8;\n}\n\n.modal-description {\n  margin-bottom: 32px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: colors.$primary8;\n}\n\n.modal-button {\n  width: 160px;\n}\n\n.cancel-button {\n  width: 200px;\n  margin-top: 40px;\n}\n\n.guarantee{\n  padding: 0!important;\n  margin: 0;\n\n  div, ul{\n    padding: 0;\n    margin: 0!important;\n  }\n\n  h4{\n   color: colors.$primary8; \n  }\n\n  li{\n    list-style-type: none;\n    font-weight: 300;\n    padding: 4px 0 0 18px;\n    position: relative;\n\n    span{\n      font-weight: 400;\n    }\n\n    svg{\n      vertical-align: middle;\n      margin: 0 10px;\n\n      path{\n        fill: colors.$primary8;\n      }\n    }\n\n    &:before{\n      width: 8px;\n      height: 8px;\n      position: absolute;\n      left: 0;\n      top: 15px;\n      content: '';\n      display: inline-block;\n      border-radius: 50%;\n      background-color: colors.$primary2;\n    }\n  }\n\n  &:not(:last-child){\n    border-bottom: 1px solid colors.$primary2;\n    border-radius: 0;\n    padding-bottom: 10px!important;\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .secondary-cards {\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n  }\n\n  .card {\n    &:not(:last-child) {\n      margin-bottom: 0;\n    }\n\n    &:nth-child(2) {\n      order: 1;\n    }\n    &:nth-child(4) {\n      order: 1;\n    }\n  }\n\n  .cancel-button {\n    width: 100%;\n  }\n}\n.custom-info-message {\n  display: flex;\n  align-items: center; /* Aligne verticalement */\n  justify-content: space-between;\n  background-color: #FEF9F0;\n  border: 1px solid #FBD298;\n  color: #B94402;\n}\n\n.custom-claim-button {\n  padding: 0 20px; /* Ajuster en fonction de la taille du texte */\n  font-size: inherit; /* Pour qu'il suive la taille du texte */\n  width: auto; /* S'assure que le bouton prend la taille du texte */\n  white-space: nowrap; /* Empêche le texte de se couper en plusieurs lignes */\n}\n\n.custom-claim-button:hover {\n  background-color: #FEF9F0; /* Si vous voulez que le bouton change au hover */\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"contract-item": `ContractItem_contract-item__3TrEX`,
	"custom-background": `ContractItem_custom-background__SNIMS`,
	"info-message": `ContractItem_info-message__IPFlq`,
	"claim-button": `ContractItem_claim-button__qctcC`,
	"card": `ContractItem_card__MO5nl`,
	"main-card": `ContractItem_main-card__4GrNQ`,
	"secondary-cards": `ContractItem_secondary-cards__Jl1az`,
	"contract-name": `ContractItem_contract-name__yBMj4`,
	"download": `ContractItem_download__Bspw0`,
	"price": `ContractItem_price__f7YlF`,
	"modal-title": `ContractItem_modal-title__Uc+i1`,
	"modal-description": `ContractItem_modal-description__aCoTT`,
	"modal-button": `ContractItem_modal-button__SVaOZ`,
	"cancel-button": `ContractItem_cancel-button__f+-Gc`,
	"guarantee": `ContractItem_guarantee__cQaUs`,
	"custom-info-message": `ContractItem_custom-info-message__F7n3d`,
	"custom-claim-button": `ContractItem_custom-claim-button__ZafVJ`
};
export default ___CSS_LOADER_EXPORT___;
